import React, { ComponentProps, ReactNode } from 'react';
import { createGlobalStyle } from 'styled-components';
import Modal from './Modal';
import FocusLock from 'react-focus-lock';
import { keyCodes } from '../../constants/keycodes';
import { ModalHeaderProps } from './ModalHeader';
import VStack from '../VStack';
interface ModalProps extends ModalHeaderProps {
  show: boolean;
  children?: React.ReactNode;
  header?: ComponentProps<typeof VStack>;
  title?: string;
  height?: string[] | string | number[] | number | undefined;
  closable?: boolean;
  onClose?: () => void;
  showCloseButton?: boolean;
  color?: string;
  closeIcon?: ReactNode;
}

const GlobalStyle = createGlobalStyle({
  html: {
    overflowY: 'hidden',
  },
});

export const ModalInfo = ({
  show,
  header,
  children,
  title,
  closable = true,
  onClose,
  showCloseButton = false,
  color,
  height = '100%',
  closeIcon,
  ...rest
}: ModalProps & ComponentProps<typeof VStack>) => {
  function onKeyDown(event: React.KeyboardEvent<HTMLElement>) {
    if (!event) return;
    if (event.key === keyCodes.Escape) onClose?.();
  }

  if (!show) return <></>;
  return (
    <FocusLock>
      <Modal onClick={closable ? onClose : undefined} onKeyDown={onKeyDown} role="dialog" aria-hidden="false" aria-modal="true" aria-labelledby="modal-body">
        <GlobalStyle />
        <Modal.Window role="document" maxHeiht={height} {...rest}>
          <Modal.Window.Header title={title} onClose={onClose} color={color} titleFontSize={rest.titleFontSize} closeIcon={closeIcon}>
            {header}
          </Modal.Window.Header>
          <Modal.Window.Body tabindex="0" id="modal-body" minHeight={0}>
            {children}
          </Modal.Window.Body>
          <Modal.Window.Footer onClose={onClose} show={showCloseButton} />
        </Modal.Window>
      </Modal>
    </FocusLock>
  );
};

ModalInfo.displayName = 'ModalInfo';
